import React from 'react';
import ReactTable from 'react-table';
import ReactJsonTree from 'react-json-tree';

function ShortSize(props) {
    if (typeof props.value !== 'number') {
        return 'NaN';
    }
    if (props.value < 4 * 1024) {
        return props.value.toFixed(2);
    } else if (props.value < 4 * 1024 * 1024) {
        return `${(props.value / 1024).toFixed(2)} K`;
    } else if (props.value < 4 * 1024 * 1024 * 1024) {
        return `${(props.value / 1024 / 1024).toFixed(2)} M`;
    } else {
        return `${(props.value / 1024 / 1024 / 1024).toFixed(2)} G`;
    }
}

export class MongoStats extends React.PureComponent {
    STATS_COLUMNS = [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: "Size",
            accessor: 'stats.size',
            Cell: row => <ShortSize value={row.value} />,
        },
        {
            Header: "Count",
            accessor: 'stats.count',
        },
        {
            Header: "Average Object Size",
            accessor: 'stats.avgObjSize',
            Cell: row => <ShortSize value={row.value} />,

        },
        {
            Header: "Storage Size",
            accessor: 'stats.storageSize',
            Cell: row => <ShortSize value={row.value} />,
        },
        {
            Header: "Index Count",
            accessor: 'stats.nindexes',
        },
        {
            Header: "Index Total Size",
            accessor: 'stats.totalIndexSize',
            Cell: row => <ShortSize value={row.value} />,
        },
    ];

    state = {
        results: null,
    };

    componentDidMount() {
        this.fetchCollectionList();
    }

    async fetchCollectionList() {
        const response = await fetch('/api/collectionstats');
        const result = await response.json();
        this.setState({ results: result.results });
    }

    createSubComponent = row => {
        return <ReactJsonTree data={row.original} />;
    }

    render() {
        if (!this.state.results) {
            return "Loading...";
        }
        window.stats = this.state.results;
        return (
            <ReactTable
                data={this.state.results}
                columns={this.STATS_COLUMNS}
                pageSize={this.state.results.length}
                showPagination={false}
                SubComponent={this.createSubComponent}
            />
        );
    }
}
